import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
import { Drawer, Slider, message, Input } from "antd";
import defaultPng from "assets/images/home/defaultPng.png";
import editI from "assets/images/home/editI.png";
import leftArrow from "assets/images/home/leftArrow.png";
import copy1 from "assets/images/home/copy1.png";
import editPng from "assets/images/home/edit.png";
import num from "assets/images/home/num.png";
import { put_defaultInviteCode, put_remarkInviteCode, post_addInviteCode } from "@/api/referral";
import InviteesDrawer from "./inviteesDrawer";
import Nodata from "assets/images/home/nodata.png";
import CommonDrawer from "../../../App/commonDrawer";
import copy from "copy-to-clipboard";
const { XtContext } = Context;

const { useTranslation, useDocumentWidth } = Hooks;
const { getOrigin, getUrl } = Util;

function AllInviteDrawer(props) {
  const { isShowModal, onClose, inviteCodeList, getInviteCodeList, getProfileInfo, onOkAddInviteModal, onCloseAddInviteModal, isShowAddInviteModal } = props;
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const { lang } = appState;
  const [messageApi, contextHolder] = message.useMessage();
  const copyToClipboard = (text) => navigator.clipboard?.writeText && navigator.clipboard.writeText(text);
  const [isShowInviteesModal, setIsShowInviteesModal] = useState(false);
  const [inviteCode, setInviteCode] = useState("");

  const [value, setValue] = useState(40);

  const [remarkCurrent, setRemarkCurrent] = useState("");
  const [isShowEditModal, setIsShowEditModal] = useState(false);
  const [userId, setUserId] = useState(null);

  const onChangeRemark = (e) => {
    console.log("onChange: ", e.target.value);
    setRemarkCurrent(e.target.value);
  };

  const onCloseEditModal = () => {
    setIsShowEditModal(false);
  };

  const onOkEditModal = (record) => {
    setRemarkCurrent(record.remark);
    setIsShowEditModal(true);
    setUserId(record.id);
  };

  const onSaveEdit = () => {
    put_remarkInviteCode(userId, {
      successPop: true,
      data: { remark: remarkCurrent },
    }).then((result) => {
      getInviteCodeList();
      onCloseEditModal();
    });
  };

  const onChange = (value) => {
    console.log("onChange: ", value);
    setValue(value);
  };

  const onCloseInviteesModal = () => {
    setIsShowInviteesModal(false);
  };

  const onOkInviteesModal = (record) => {
    setIsShowInviteesModal(true);
    setInviteCode(record.inviteCode);
  };

  // 复制Code
  const onCopyCode = (inviteCode) => {
    copy(inviteCode);
    messageApi.open({
      type: "success",
      content: t("home.copySuccess"),
    });
  };

  // 复制链接
  const onCopyLink = (copyLinkUrl) => {
    copy(copyLinkUrl);
    messageApi.open({
      type: "success",
      content: t("home.copySuccess"),
    });
  };

  const defaultInit = (id) => {
    put_defaultInviteCode({
      successPop: true,
      data: { id },
    }).then(() => {
      getProfileInfo();
      getInviteCodeList();
      onClose(); // 关闭编辑弹窗，以便看到数据更新
    });
  };

  const onSave = () => {
    post_addInviteCode({
      successPop: true,
      data: { selfCommissionRate: value / 100 },
    }).then((result) => {
      getInviteCodeList();
      onCloseAddInviteModal();
    });
  };

  const getRootDomain = () => {
    let domain = document.domain; //先获取当前访问的全域名
    let domain2 = domain.substring(domain.indexOf(".") + 1); //截取第一个点的位置来获取根域名,这样只能获取二级域名的根域名，如果直接是不带www的域名访问，那么就会直接获取域名的后缀
    return domain2;
  };

  return (
    <>
      {contextHolder}
      <Drawer
        title=""
        placement="bottom"
        closable={false}
        onClose={onClose}
        open={isShowModal}
        height="100%"
        className="commonDrawer allInviteDrawer"
      >
        <div className="allInvite">
          <div className="header">
            <img src={leftArrow} onClick={onClose} alt="" />
            <div className="title">{t("home.recommendAll")}</div>
          </div>
          <div className="allInvite_t">
            {inviteCodeList.length != 0 &&
              inviteCodeList?.map((item) => (
                <div key={item.id ?? item.inviteCode} className="invite">
                  <div className="inviteItem">
                    <div className="invite_l">
                      <div className="invite_l_text">{item.inviteCode}</div>
                      <img src={copy1} onClick={() => onCopyCode(item.inviteCode)} alt="" />
                    </div>
                    {item.isDefault && <div className="invite_r">{t("home.default1")}</div>}
                    {!item.isDefault && (
                      <div className="invite_rr" onClick={() => defaultInit(item.id)}>
                        {t("console.link.setDefault")}
                      </div>
                    )}
                  </div>
                  <div className="inviteItem">
                    <div className="invite_l1">
                      {t("console.manage.my")}/{t("console.manage.friend")}
                    </div>
                    <div className="invite_r1">
                      <div>
                        {(item.selfCommissionRate * 100).toFixed(0) + "%"}/{(item.inviteeCommissionRate * 100).toFixed(0) + "%"}
                      </div>
                    </div>
                  </div>
                  <div className="inviteItem">
                    <div className="invite_l1">{t("home.referralUrl")}</div>
                    <div className="invite_r1">
                      <div>{`${process.env.NEXT_PUBLIC_protocol}//www.${getRootDomain()}/${lang}/accounts/register?ref=`}</div>
                      <span>{item.inviteCode}</span>
                      <img
                        src={copy1}
                        alt=""
                        onClick={() =>
                          onCopyLink(
                            `${process.env.NEXT_PUBLIC_protocol}//www.${getRootDomain()}/${lang}/accounts/register?ref=${item.inviteCode}`
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="inviteItem">
                    <div className="invite_l1">{t("home.remark")}</div>
                    <div className="invite_r1">
                      <div>{item.remark}</div>
                      <img src={editPng} onClick={() => onOkEditModal(item)} alt="" />
                    </div>
                  </div>
                  <div className="inviteItem">
                    <div className="invite_l1">{t("home.inviteNum")}</div>
                    <div className="invite_r1">
                      <div>{item.inviteNum}</div>
                      <img src={num} onClick={() => onOkInviteesModal(item)} alt="" />
                    </div>
                  </div>
                </div>
              ))}
            {inviteCodeList.length == 0 && (
              <div className="nodata">
                <img src={Nodata} className="nodataImg" alt="" />
                <div className="nodataTitle">{t("home.NoRecent")}</div>
              </div>
            )}
          </div>
          <div className="allInvite_b">
            <div className="invitation_bb">
              {t("home.createNumber")}
              <span>{20 - inviteCodeList.length}</span>
            </div>
            <div className="invitation_edit" onClick={onOkAddInviteModal}>
              <div className="add_new">{t("home.addNew")}</div>
            </div>
          </div>
        </div>
      </Drawer>
      {isShowInviteesModal && (
        <InviteesDrawer
          isShowModal={isShowInviteesModal}
          onClose={onCloseInviteesModal}
          getInviteCodeList={getInviteCodeList}
          inviteCode={inviteCode}
        />
      )}
      <CommonDrawer title={t("home.addRecommended")} isShowModal={isShowAddInviteModal} onClose={onCloseAddInviteModal} height={229}>
        <div className="AddInviteCodeDrawer">
          <div className="tuijian">{t("console.link.setEarnBili")}</div>
          <div>
            <Slider defaultValue={40} tooltip={{ formatter: null }} onChange={onChange} />
          </div>
          <div className="bili">
            <div className="my">
              {t("console.manage.my")}
              <span>{value}%</span>
            </div>
            <div className="you">
              {t("console.manage.friend")}
              <span>{100 - value}%</span>
            </div>
          </div>
          <div className="foot1">
            <div className="cancel" onClick={onCloseAddInviteModal}>
              {t("home.cancel")}
            </div>
            <div className="save" onClick={onSave}>
              {t("home.save")}
            </div>
          </div>
        </div>
      </CommonDrawer>
      <CommonDrawer title={t("console.link.editComment")} isShowModal={isShowEditModal} onClose={onCloseEditModal} height={213}>
        <div className="EditRemarkDrawer">
          <div className="editRemark">
            <Input onChange={onChangeRemark} defaultValue={remarkCurrent} allowClear showCount maxLength={20} />
          </div>
          <div className="foot1">
            <div className="cancel" onClick={onCloseEditModal}>
              {t("home.cancel")}
            </div>
            <div className="save" onClick={onSaveEdit}>
              {t("home.save")}
            </div>
          </div>
        </div>
      </CommonDrawer>
    </>
  );
}

export default AllInviteDrawer;
